import React from 'react';
import {Typography, Container, Button, Box, Grid, Link} from '@material-ui/core';
import {useTheme} from '@material-ui/core/styles';
import LazyImage from "./App/LazyImage";

const Error404Page = () => {
    const theme = useTheme();
    return (<>
        <Box bgcolor="white.main" pb={20} pt={2}>
            <Container maxWidth="lg">
                <Grid container spacing={1} alignItems="center">
                    <Grid item xs={12} sm={6}>
                        <Box mt={8}>
                            <Typography gutterBottom={true} variant="h3" component="h1"><Box component="span" color="secondary.main">404:</Box> Page Not Found</Typography>
                            <Typography gutterBottom={true}>Oops! The page you’re looking for can’t be found.</Typography>
                            <Box maxWidth={{xs:'100%', sm:300}}>
                                <Button fullWidth variant="contained" style={{color: 'white'}} href="/" color="secondary">Go home</Button>
                            </Box>
                            <Box mt={3}>
                                <Typography><small>If you continue to encounter errors, please visit our <Link target="_blank" rel="noopener noreferrer" style={{color: theme.palette.secondary.main}} href="https://giftyasupport.zendesk.com/hc/en-us">help center</Link>.</small></Typography>
                            </Box>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <LazyImage style={{maxWidth: '100%', height: 'auto'}} width="576px" height="420px" src="https://d2kn7nb9ubajli.cloudfront.net/assets/404.png" />
                    </Grid>
                </Grid>
            </Container>
        </Box>
    </>);
};
export default Error404Page;